<template>
  <BCard v-if="group">

    <!-- Group Info: Input Fields -->
    <ValidationObserver ref="form">
      <BForm @submit.prevent="onSubmit">

        <BRow>
          <BCol cols="12" md="4" >
            <h3>{{$t('Group data')}}</h3>
          </BCol>
        </BRow>
        
        <BRow> 
          <TextInputValidated vsName="Name" :vsModel.sync="group.name" vsMd="4" vsRequired vsRules="required"/>
          <vSelectValidated vsName="Status" :vsModel.sync="group.status" :vsOptions="statusOptions" vsLabel="label" vsMd="4" vsRequired vsRules="required" :vsReduce="status=>status.value" />
        </BRow>

        <BRow class="mt-2" >
          <BCol cols="12" md="4" >
            <h3>{{$t('Contact data')}}</h3>
          </BCol>
        </BRow>

        <BRow>
          <TextInputValidated vsName="Email" :vsModel.sync="group.email" vsMd="4" vsRequired vsRules="required|email"/>
          <TextInputValidated vsName="Phone" :vsModel.sync="group.phone" vsMd="4" />
          <TextInputValidated vsName="Phone 2" :vsModel.sync="group.phone2" vsMd="4"/>
        </BRow>

        <BRow class="mt-2">
          <BCol cols="12" md="4" >
            <h3>Datos fiscales</h3>
          </BCol>
        </BRow>

        <BRow>
          <TextInputValidated vsName="Business name" :vsModel.sync="group.company_name" vsMd="4"/>
          <TextInputValidated vsName="Address" :vsModel.sync="group.address" vsMd="4" :vsRequired = "group.company_name ? false : true" :vsRules="group.company_name ? 'required' : ''" />
          <TextInputValidated vsName="Town" :vsModel.sync="group.city" vsMd="4" :vsRequired = "group.company_name ? false : true" :vsRules="group.company_name ? 'required' : ''"  />
          <NumberInputValidated vsName="Postal code" :vsModel.sync="group.postal_code" vsMd="4" :vsRequired = "group.company_name ? false : true" :vsRules="group.company_name ? 'required' : ''" />
          <vSelectValidated vsName="Province" :vsModel.sync="group.province_id" :vsOptions="provinces" :vsReduce="pr=> pr.id" vsLabel="name" vsMd="4" vsRequired vsRules="required"/>
          <vSelectValidated vsName="Country" :vsModel.sync="group.country_id" :vsOptions="countries" :vsReduce="country=> country.id" vsLabel="name" vsMd="4" vsRequired vsRules="required"/>            
          <vSelectValidated v-if="pitsOptions" vsName="IRPF" :vsModel.sync="group.pit_id" :vsOptions="pitsOptions" vsLabel="name" vsMd="4"  :vsReduce="pit => pit.id" :vsClearable="true"/>
          <NumberInputValidated vsName="Días vencimiento factura" :vsModel.sync="group.payment_days" vsRequired vsMd="4" />       
        </BRow>

        <!-- Cajas -->
        <BRow class="mt-2">
            <BCol cols="12" md="4">
              <h3>Configuración de cajas</h3>
            </BCol>
        </BRow>

        <BRow>
          <NumberInputValidated vsName="Saldo inicial" :vsModel.sync="group.initial_balance" vsMd="6" vsRequired />
        </BRow>

      <!-- Action Buttons -->
      <BRow class="mt-3">
        <BCol cols="12" md="4" >
          <BButton variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
          <BButton variant="outline-secondary" type="reset" @click="showListGroup=true; showEditGroup=false" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
        </BCol>
      </BRow>
    </BForm>
  </ValidationObserver>

  </BCard>
</template>

<script>
import { BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormCheckboxGroup, BFormInvalidFeedback } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import { inject, onUnmounted, ref } from '@vue/composition-api'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import vSelectValidated from '@/components/forms/vSelectValidated.vue'
import groupsStoreModule from '../groupsStoreModule'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
import router from '@/router'
import store from '@/store'
import axios from '@axios'
import { updateGroup } from '@/composables/groupService'


export default {
  components: { NumberInputValidated, TextInputValidated, vSelectValidated, BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormCheckboxGroup, BFormInvalidFeedback, ValidationProvider, ValidationObserver, vSelect },
  setup(){
    const { getValidationState } = formValidation()
    const { deletePopup, errorToast, successToast } = popups()
    const countries = inject('countries')
    const provinces = inject('provinces')
    const GROUP_MODULE = 'groups'
    const group = inject('group')
    const form = ref(null)
    const statusOptions = [
        { label: i18n.t('Active'), value: true },
        { label: i18n.t('Inactive'), value: false },
      ]
    const pitsOptions = ref(null)
    const showEditGroup = inject('showEditGroup')
    const showListGroup = inject('showListGroup')

    const onSubmit = async function(){
      
      if (group.value.bank_account && !/^[A-Za-z]{2}\d{22}$/.test(group.value.bank_account)) {
        errorToast("Formato IBAN incorrecto")
        return
      }

      form.value.validate().then(async success => {
        if(success){
          let response = await updateGroup(group.value)
          if(response.data.success){
            successToast('Sucursal modificada')
            showEditGroup.value = false
            showListGroup.value = true
          } else {
            errorToast("Error modificando la sucursal")
          }
        }
      })
    }

    const fetchPits = () => {
      axios.get('pits').then((response) => { pitsOptions.value=response.data})
    }

    fetchPits()

    extend('required', required)
    extend('email', email)

    if(!store.hasModule(GROUP_MODULE)) {
      store.registerModule(GROUP_MODULE, groupsStoreModule)
    }

    onUnmounted(() => {
      if(store.hasModule(GROUP_MODULE)) {
        store.unregisterModule(GROUP_MODULE)
      }
    })

    return {
      getValidationState,
      statusOptions,
      deletePopup,
      countries,
      provinces,
      onSubmit,
      group,
      form,
      pitsOptions,
      showEditGroup,
      showListGroup
    }

  },

}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
../../../../composables/groupsStoreModule